module.exports = __webpack_public_path__ + "img/simplepay_horizontal_02.eeeb7d05.png";